"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { useForm } from "react-hook-form";

import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { unlockBeta } from "./actions";

export default function UnlockPage() {
  const router = useRouter();
  const [loading, setLoading] = useState(false);

  // Initialize shadcn form without Zod
  const form = useForm({
    defaultValues: {
      betaPassword: "",
    },
  });

  async function onSubmit(values: { betaPassword: string }) {
    setLoading(true);
    
    const result = await unlockBeta(values.betaPassword);

    if (result.success) {
      router.push("/sign-in");
      router.refresh();
    } else {
      // Manually set the error on the field so shadcn displays it
      form.setError("betaPassword", { 
        type: "manual", 
        message: result.error 
      });
      setLoading(false);
    }
  }

  return (
    <div className="w-full flex flex-col justify-center items-center mt-32 mb-32 px-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>LawLibrary.AI</CardTitle>
          <CardDescription>
            LawLibrary.AI is currently invite-only. Please enter the access code.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
              <FormField
                control={form.control}
                name="betaPassword"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Access code</FormLabel>
                    <FormControl>
                      <Input 
                        placeholder="" 
                        type="password" 
                        disabled={loading}
                        {...field} 
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <Button type="submit" size="lg" className="w-full" disabled={loading}>
                {loading ? "Verifying..." : "Unlock"}
              </Button>
            </form>
          </Form>
        </CardContent>
      </Card>
    </div>
  );
}